// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-assets_seshy_js","_embroider_babel-loader-9_index_js_variant_name_dev_runtime_browser_optimizeForProduction_fal-49688b"], () => (__webpack_require__("./assets/seshy.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
